<div class="tw-block tw-w-full tw-flex-[1] tw-overflow-x-hidden tw-h-screen tw-relative tw-font-lexend">
  <div class="tw-flex tw-flex-col tw-flex-[1] tw-h-full">
    <div class="tw-fixed tw-left-0 tw-top-0 tw-px-6 tw-py-4 tw-z-10 tw-bg-white tw-w-full">
      <span (click)="back()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_884_36" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <rect width="24" height="24" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_884_36)">
          <path d="M10.875 19.3L4.275 12.7C4.175 12.6 4.104 12.4916 4.062 12.375C4.02067 12.2583 4 12.1333 4 12C4 11.8666 4.02067 11.7416 4.062 11.625C4.104 11.5083 4.175 11.4 4.275 11.3L10.875 4.69996C11.0583 4.51663 11.2873 4.42063 11.562 4.41196C11.8373 4.40396 12.075 4.49996 12.275 4.69996C12.475 4.88329 12.5793 5.11229 12.588 5.38696C12.596 5.66229 12.5 5.89996 12.3 6.09996L7.4 11H18.575C18.8583 11 19.096 11.0956 19.288 11.287C19.4793 11.479 19.575 11.7166 19.575 12C19.575 12.2833 19.4793 12.5206 19.288 12.712C19.096 12.904 18.8583 13 18.575 13H7.4L12.3 17.9C12.4833 18.0833 12.5793 18.3166 12.588 18.6C12.596 18.8833 12.5 19.1166 12.3 19.3C12.1167 19.5 11.8833 19.6 11.6 19.6C11.3167 19.6 11.075 19.5 10.875 19.3Z" fill="currentColor"/>
        </g>
      </svg>
      </span>
    </div>
    <div class="tw-w-full tw-flex-auto tw-overflow-y-auto tw-pt-16">
      <div class="tw-w-full tw-flex tw-flex-col tw-px-6 tw-pt-4 tw-pb-12">
        <div class="tw-mb-4">
          <h1 class="tw-text-500 tw-text-gray-800" i18n="@@clinicallyProvenTech">Our Clinically Proven Technologies</h1>
          <p class="tw-text-100 tw-text-gray-800" i18n="@@rootedInResearch">Rooted in scientific research</p>
        </div>
        <ng-container *ngFor="let card of ClinicalTechnologyHighlights[displayLanguage]">
          <div class="tw-w-full tw-relative tw-rounded-2xl tw-overflow-hidden tw-mb-6">
            <img [src]="card.image" class="tw-w-full">
            <div class="tw-absolute tw-bottom-4 tw-left-4">
              <h1 class="tw-text-600 tw-mb-2" [innerHTML]="card.title"></h1>
              <p class="tw-text-200 tw-font-normal">{{ card.subTitle }}</p>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
